export default __webpack_public_path__ + "static/bg-gallery-photo-0f9e33688f8b71f24b331a4961f88140.webp";